export const GUIDE_MAPS = [
  "Abyss",
  "Ascent",
  "Bind",
  "Breeze",
  "Corrode",
  "Fracture",
  "Haven",
  "Icebox",
  "Lotus",
  "Pearl",
  "Split",
  "Summit",
  "Sunset",
];

export const GUIDE_CATEGORY_DEFINITIONS = [
  {
    key: "macro",
    title: "Map Macro Guides",
    description:
      "Teamwide map structure, site approaches, default rotations, and macro anchors that apply beyond one agent.",
    emptyMessage: "coming soon...",
  },
  {
    key: "coordinated",
    title: "Coordinated-Play Playbooks",
    description:
      "Multi-player comp guides, layered utility plans, and reusable team structures for coordinated execution.",
    emptyMessage: "coming soon...",
  },
  {
    key: "mvsk",
    title: "MVSK Basics",
    description: "",
    emptyMessage: "Coming Soon",
  },
  {
    key: "agent",
    title: "Agent Mastery Guides",
    description:
      "Agent-specific setups, utility concepts, and execution reminders for mastering a role on a given map.",
    emptyMessage: "coming soon...",
  },
  {
    key: "pro",
    title: "Pro-Player Analysis",
    description:
      "Structured pro VOD analysis and transferable takeaways extracted from high-level competitive play.",
    emptyMessage: "coming soon...",
  },
];

export const GUIDE_CATEGORY_CONTENT = {
  macro: {
    Bind: [{ label: "Map Macro", path: "/Bind-Map-Macro" }],
    Split: [{ label: "Map Macro", path: "/Split-Map-Macro" }],
  },
  coordinated: {
    Bind: [{ label: "NRG 2026 Bind Comp", path: "/playbook/NRG2026BindComp" }],
    Split: [{ label: "SEN Split Comp", path: "/playbook/Split-SEN-Comp" }],
  },
  mvsk: Object.fromEntries(
    GUIDE_MAPS.map((map) => [map, [{ label: "Coming Soon", path: "", disabled: true }]])
  ),
  agent: {
    Bind: [{ label: "Gekko", path: "/Bind-Gekko", disabled: true }],
    Corrode: [{ label: "Yoru", path: "/Corrode-Yoru", disabled: true }],
    Haven: [{ label: "KJ", path: "/Haven-KJ" }],
  },
  pro: {},
};

function normalizeGuideItem(item) {
  if (!item || typeof item !== "object") {
    return null;
  }

  return {
    label: String(item.label || "Guide Chapter"),
    path: item.path ? String(item.path) : "",
    disabled: item.disabled === true,
  };
}

export function buildGuideCategorySections() {
  return GUIDE_CATEGORY_DEFINITIONS.map((definition) => {
    const contentByMap = GUIDE_CATEGORY_CONTENT[definition.key] || {};
    const maps = GUIDE_MAPS.map((name) => {
      const items = (Array.isArray(contentByMap[name]) ? contentByMap[name] : [])
        .map(normalizeGuideItem)
        .filter(Boolean);
      const liveItemCount = items.filter((item) => item.path && !item.disabled).length;

      return {
        name,
        items,
        liveItemCount,
      };
    });

    const publishedCount = maps.reduce((total, map) => total + map.liveItemCount, 0);

    return {
      ...definition,
      maps,
      publishedCount,
      emptyMapCount: maps.filter((map) => map.liveItemCount === 0).length,
    };
  });
}
